import "./index.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";

import { Routes } from "./modules/core/routes/react-router-lazy";

if (!import.meta.env.VITE_API_URL) {
  console.warn(
    "VITE_API_URL is not set, defaulting to http://localhost:5004/api"
  );
}

const rootElement = document.getElementById("root")!;
registerSW({
  onNeedRefresh() {
    console.log("Hay una nueva versión disponible.");
    window.location.reload(); // Recarga la página automáticamente
  },
  onOfflineReady() {
    console.log("La aplicación ahora está lista para trabajar offline.");
  },
});

if (!rootElement.innerHTML) {
  const root = createRoot(rootElement);
  root.render(
    <StrictMode>
      <Routes />
    </StrictMode>
  );
}
